import { z } from 'zod';

export const StripeRevenueDetailsSchema = z.object({
  total: z.number(),
  successful: z.number(),
  successfulCount: z.number(),
  totalCount: z.number(),
});
export type StripeRevenueDetails = z.infer<typeof StripeRevenueDetailsSchema>;

export const StripeRefundDetailsSchema = z.object({
  total: z.number(),
  count: z.number(),
});
export type StripeRefundDetails = z.infer<typeof StripeRefundDetailsSchema>;

export const StripeCustomerDetailsSchema = z.object({
  signups: z.number(),
  paying: z.number(),
  conversionRate: z.number(),
});
export type StripeCustomerDetails = z.infer<typeof StripeCustomerDetailsSchema>;

export const StripeSubscriptionDetailsSchema = z.object({
  active: z.number(),
  cancelledInPeriod: z.number(),
  churnRate: z.number(),
});
export type StripeSubscriptionDetails = z.infer<
  typeof StripeSubscriptionDetailsSchema
>;

export const StripeBalanceEntrySchema = z.object({
  type: z.string(),
  count: z.number(),
  amount: z.number(),
});
export type StripeBalanceEntry = z.infer<typeof StripeBalanceEntrySchema>;

export const StripeRevenueMetricsSchema = z.object({
  org: z.string(),
  periodStart: z.iso.datetime(),
  periodEnd: z.iso.datetime(),
  revenue: StripeRevenueDetailsSchema,
  refunds: StripeRefundDetailsSchema,
  customers: StripeCustomerDetailsSchema,
  subscriptions: StripeSubscriptionDetailsSchema,
  mrr: z.number(),
  balanceByType: z.array(StripeBalanceEntrySchema),
});
export type StripeRevenueMetrics = z.infer<typeof StripeRevenueMetricsSchema>;

export const StripeSalesResponseDTOSchema = z.object({
  metrics: z.array(StripeRevenueMetricsSchema),
  orgs: z.array(z.string()),
});
export type StripeSalesResponseDTO = z.infer<
  typeof StripeSalesResponseDTOSchema
>;
